import React from "react";
import { Link } from "react-router-dom";
import { Users, MapPin, Smartphone } from "lucide-react";

const ago = (iso) => {
  if (!iso) return "";
  const s = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 1000));
  if (s < 60) return `${s}s ago`;
  return `${Math.round(s / 60)}m ago`;
};

const pageLabel = (v) => {
  if (v.on_site_now && v.campsite_name) return null;
  const p = v.path || "";
  if (!p) return "Unknown page";
  if (p === "/") return "Home page";
  return p;
};

function VisitorRow({ v, i }) {
  const page = pageLabel(v);
  return (
    <li className="px-2.5 py-2 border-b hairline last:border-b-0 flex items-start gap-2" data-testid={`live-visitor-${i}`}>
      <span className={`mt-1.5 w-2 h-2 rounded-full shrink-0 ${v.active_now ? "bg-[#0a7f3f] animate-pulse" : "bg-[#c8c8c8]"}`} />
      <div className="min-w-0 flex-1">
        <div className="flex items-center justify-between gap-2">
          <span className={`text-xs font-bold truncate ${v.kind === "signed_in" ? "text-[#0e0e0e]" : "text-[#555]"}`} data-testid={`live-visitor-label-${i}`}>
            {v.kind === "signed_in" ? "✓ " : "○ "}{v.label}
          </span>
          <span className="mono text-[9px] text-[#888] shrink-0">{v.active_now ? "active now" : ago(v.last_seen)}</span>
        </div>
        {v.campsite_id && (
          <Link
            to={`/campsites/${v.campsite_id}`}
            target="_blank"
            rel="noreferrer"
            className="block text-[11px] text-[#ff4500] hover:underline truncate"
            data-testid={`live-visitor-site-${i}`}
          >
            {v.on_site_now ? "Viewing: " : `Last viewed (${ago(v.last_site_at)}): `}
            {v.campsite_name || v.campsite_id}{v.campsite_region ? ` · ${v.campsite_region}` : ""}
          </Link>
        )}
        {page && <div className="text-[11px] text-[#444] truncate" data-testid={`live-visitor-page-${i}`}>On: {page}</div>}
        <div className="mono text-[9px] text-[#888] flex flex-wrap gap-x-3 mt-0.5">
          {v.city && <span className="inline-flex items-center gap-0.5"><MapPin className="w-2.5 h-2.5" />{v.city}</span>}
          {v.device && <span className="inline-flex items-center gap-0.5"><Smartphone className="w-2.5 h-2.5" />{v.device}</span>}
          {v.first_seen && <span>arrived {ago(v.first_seen)}</span>}
        </div>
      </div>
    </li>
  );
}

export const LiveVisitorsList = ({ visitors }) => (
  <div className="mb-4" data-testid="live-visitors">
    <div className="eyebrow mb-1.5 inline-flex items-center gap-1.5">
      <Users className="w-3 h-3" /> Real people on the site (last 5 min)
    </div>
    {visitors?.length ? (
      <ul className="border hairline bg-white max-h-[360px] overflow-y-auto">
        {visitors.map((v, i) => <VisitorRow key={i} v={v} i={i} />)}
      </ul>
    ) : (
      <div className="border hairline bg-white px-2.5 py-3 text-xs text-[#888]" data-testid="live-visitors-empty">
        No real visitors in the last 5 minutes.
      </div>
    )}
  </div>
);
